export default "/fonts/vendor/tinymce/skins/lightgray/tinymce.woff?a820a9690a7cf2192ff46b3e9edc46d2";